/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Renderer2, ElementRef, OnChanges, inject, input } from '@angular/core';

@Directive({
  selector: '[cmgHighlight]',
})
export class CmgHighlightDirective implements OnChanges {
  private readonly _el = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);

  readonly searchTerm = input<string>();
  readonly text = input<string>();
  readonly caseSensitive = input(false);

  ngOnChanges() {
    const searchTerm = this.searchTerm();
    const text = this.text();
    if (!searchTerm || !searchTerm.length || !text) {
      this._renderer.setProperty(this._el.nativeElement, 'innerHTML', text);
      return;
    }

    this._renderer.setProperty(this._el.nativeElement, 'innerHTML', this.getHighlightedText());
  }

  getHighlightedText() {
    const regex = new RegExp(this.searchTerm(), this.caseSensitive() ? 'g' : 'gi');
    const newText = this.text().replace(regex, (match: string) => {
      return `<span class="highlight cmg-highlight">${match}</span>`;
    });

    return newText;
  }
}
